<template>
    <div class="login-wrapper">
        <div class="login-box">
            <h3>{{ $loginTL.loginText }}</h3>
            <v-form ref="form" v-model="form.valid" lazy-validation>
                <label>
                    <span class="tips">{{ $loginTL.loginAccountPrompt }}</span>
                    <v-text-field
                        id="login_field"
                        class="form-control"
                        v-model="form.username"
                        :rules="nameRules"
                        :error-messages="errors.nameError"
                        :placeholder="$loginTL.enterAccount"
                        ref="username"
                        required
                    />
                </label>
                <label>
                    <span class="tips">{{ $loginTL.passwordPrompt }}</span>
                    <v-text-field
                        id="password"
                        class="form-control"
                        maxlength="100"
                        type="password"
                        v-model="form.password"
                        :rules="passwordRules"
                        :placeholder="$loginTL.enterPassword"
                        required
                    />
                </label>
                <div class="validation">
                    <span class="tips">{{ $loginTL.verifyPrompt }}</span>
                    <div class="ant-form-space d-flex">
                        <v-text-field
                            id="login-captcha"
                            class="form-control"
                            type="text"
                            v-model="form.captcha"
                            :rules="captchaRules"
                            :error-messages="errors.captchaError"
                            size="6"
                            required
                            ref="captchaInput"
                        />
                        <div class="captcha">
                            <captcha
                                ref="captcha"
                                @captcha="getCaptchaConfig"
                            />
                        </div>
                    </div>
                </div>
                <v-btn
                    type="submit"
                    :class="['btn submit gradient-bg', loading && 'active']"
                    @click.prevent="on_submit"
                >
                    <svg class="loading-icon" viewBox="0 0 24 24">
                        <path
                            fill="currentColor"
                            d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                        />
                    </svg>
                    <span>{{ $loginTL.login }}</span>
                </v-btn>
            </v-form>
        </div>
    </div>
</template>

<script>
import captcha from "./captcha";
import Router from "vue-router";
import { mapMutations, mapState } from "vuex";

export default {
    name: "login-form",
    components: {
        captcha,
    },
    data() {
        return {
            nameRules: [
                (v) => !!v || `${this.$loginTL.account}${this.$loginTL.noNull}`,
            ],
            passwordRules: [
                (v) =>
                    !!v ||
                    `${this.$loginTL.passwordPrompt}${this.$loginTL.noNull}`,
            ],
            captchaRules: [
                (v) =>
                    !!v || `${this.$loginTL.verifyCode}${this.$loginTL.noNull}`,
            ],
            form: {
                valid: false,
                username: "",
                password: "",
                captcha: "",
                key: "",
            },
            errors: {
                nameError: "",
                captchaError: "",
            },
            loading: false,
        };
    },
    computed: {},
    mounted() {
        this.$refs.username.focus();
    },
    methods: {
        ...mapMutations("triggerEvtents", ["updateGetMenusData"]),
        on_submit() {
            let validate = this.$refs.form.validate();
            validate && this.logo_in();
        },

        async getCaptchaConfig(captcha) {
            this.form.key = captcha.key;
        },

        async logo_in() {
            let loginInfo = {
                email: this.form.username,
                password: this.form.password,
                captcha: this.form.captcha,
                key: this.form.key,
            };
            this.loading = true;
            try {
                //  登录成功，跳转到首页
                await this.$store.dispatch("login", loginInfo, this);

                this.loginded();
            } catch (e) {
                this.loading = false;
                this.focusWhenError(e);
                this.$refs.captcha?.reload();
                throw e;
            }
        },

        focusWhenError(e) {
            if (e?.response?.status !== 422) {
                this.errors.captchaError = this.errors.nameError = "";
                return;
            }

            const errors = e.response.data.errors;

            // 如果只是验证码错了，则聚焦验证码
            // 否则聚焦用户名
            if (Object.keys(errors).length === 1 && errors.captcha) {
                this.$refs.captchaInput?.focus();
                this.errors.captchaError = errors.captcha[0];
            } else {
                this.$refs.username.focus();
                this.errors.nameError = errors.email[0];
                this.errors.captchaError = "";
            }
        },

        loginded() {
            this.$router
                .push(this.$route.query.redirect || "/")
                .then(() => {
                    //  请求导航数据
                    this.updateGetMenusData();
                })
                .catch((e) => {
                    if (!Router.isNavigationFailure(e)) {
                        Promise.reject(e);
                    }
                });
        },
    },
};
</script>

<style lang="scss">
.login-wrapper {
    width: 100%;

    h3 {
        font-size: 24px;
        margin-bottom: 26px;
        font-weight: normal;
    }

    label {
        display: block;
        width: 100%;
        margin-bottom: 16px;
    }

    .form-control {
        .v-input__slot {
            display: block;
            width: 100%;
            padding: 3px 0.75rem;
            font-size: 14px;
            font-weight: 400;
            background-color: $color-white;
            background-clip: padding-box;
            border: 1px solid #ced4da;
            appearance: none;
            border-radius: 0.25rem;
            transition: all 0.3s;
            outline: 0;

            &::after,
            &::before {
                display: none;
            }
        }

        &.v-input--is-focused {
            .v-input__slot {
                border-color: #40a9ff;
                box-shadow: 0 0 0 2px rgb(24 144 255 / 20%);
            }
        }

        &.error--text {
            .v-input__slot {
                border-color: #f5222d;
                box-shadow: 0 0 0 2px rgb(245 34 45 / 20%);
            }
        }

        .v-text-field__details,
        .v-messages {
            min-height: auto;
        }

        .v-messages {
            padding-top: 4px;
        }
    }
    .tips {
        font-size: 14px;
        color: #595959;
        display: block;
        margin-bottom: 8px;
    }

    .wfls-prompt {
        font-size: 12px;
        font-weight: 700;
        margin-bottom: 6px;
    }

    .submit {
        width: 100%;
        height: 40px;
        color: $color-white;
        margin-top: 24px;
        letter-spacing: 1em;
        text-indent: 1em;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

        &.active {
            opacity: 0.8;
            svg {
                display: inline-block;
            }
        }

        svg {
            display: none;
            margin-right: 10px;
        }
    }

    .error-info {
        margin-top: 8px;
        margin-bottom: 0;
        font-size: 14px;
        color: #f5222d;
    }

    .ant-form-space {
        #login-captcha {
            width: 49%;
        }
    }
}

body:not([class*="zh-"]) {
    .login-wrapper {
        .submit {
            letter-spacing: 0;
            text-indent: 0;
            span {
                font-size: 18px;
            }
        }
    }
}
</style>
